import React, { useEffect } from 'react';
import styled from 'styled-components';
import DefaultLayout from 'components/DefaultLayout';

import { Title, Network, WrongNetwork } from 'components/utils';
import TokenUI from 'components/token';
import { useHistory } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { metamaskState } from 'global/state';
import { message } from 'antd';


const BSC = (props) => {
  const history = useHistory();
  const [ metamask, setMetamask ] = useRecoilState(metamaskState);

  if ( ! metamask.connected ) {
    history.push('/');
  }


  return (
    <DefaultLayout>
      <Title>Create Your Own BSC (Binance Smart Chain) Network Token</Title>

      { metamask && metamask.network === Network.ETHEREUM &&
        <WrongNetwork>
          <p>You're currently connected to the <strong>Ethereum Network</strong>, Please change your network to Binance Smart Chain to create Binance Smart Chain token.</p>
        </WrongNetwork>
      }

      { metamask && metamask.network === Network.BSC &&
        <TokenUI />
      }

    </DefaultLayout>
  )
}

export default BSC;
